import {createActionGroup, emptyProps, props} from '@ngrx/store';
import {Bundle, Image} from '@sportngin/se-commerce-sdk/models/clare';
import {ProductManagementErrorInterface} from '../../../../../error/error-handling/product-management-error';
import {CatalogSummary} from '../../../../../models/clare';
import {BundleProductsUpdateRequest, UpdateBundleRequest} from '../../../../../models/clare/bundle';
import {BundleFormValue} from '../../../types/create-bundle.types';

export const CreateBundleActions = createActionGroup({
  source: 'Create Bundle',
  events: {
    'Add Products To Bundle Failed': props<{error: ProductManagementErrorInterface}>(),
    'Add Products To Bundle Success': props<{bundle: Bundle}>(),
    'Add Products To Bundle': props<{bundleId: number; body: BundleProductsUpdateRequest}>(),

    'Create Bundle Failed': props<{error: ProductManagementErrorInterface}>(),
    'Create Bundle Success': props<{bundleId: string}>(),
    'Create Bundle': props<{
      form: BundleFormValue;
      active: boolean;
      images?: Image[];
      productIds: number[];
    }>(),

    'Load Catalogs': emptyProps(),
    'Load Catalogs Success': props<{catalogs: CatalogSummary[]}>(),
    'Load Catalogs Failure': emptyProps(),

    'Load All Bundles Failed': props<{error: ProductManagementErrorInterface}>(),
    'Load All Bundles Success': props<{bundles: Bundle[]}>(),
    'Load All Bundles': emptyProps(),
    'Load Bundle By BundleId': props<{bundleId: number}>(),
    'Load Bundle By BundleId Success': props<{bundle: Bundle}>(),
    'Load Bundle By BundleId Failed': props<{error: ProductManagementErrorInterface}>(),
    'Load Bundles By Catalog Id': props<{catalogId: number}>(),
    'Load Bundles By Catalog Id Success': props<{bundles: Bundle[]}>(),
    'Load Bundles By Catalog Id Failed': props<{error: ProductManagementErrorInterface}>(),

    'Remove Products From Bundle Failed': props<{error: ProductManagementErrorInterface}>(),
    'Remove Products From Bundle Success': props<{bundle: Bundle}>(),
    'Remove Products From Bundle': props<{bundleId: number; body: BundleProductsUpdateRequest}>(),

    'Update Bundle Failed': props<{error: ProductManagementErrorInterface}>(),
    'Update Bundle Success': props<{bundle: Bundle}>(),
    'Update Bundle': props<{bundleId: number; body: UpdateBundleRequest}>(),
  },
});
